export enum PlatformMFAType {
  SMS = 'SMS_MFA',
  TOTP = 'SOFTWARE_TOKEN_MFA'
}

export const allowedMFATypes: PlatformMFAType[] = [PlatformMFAType.SMS, PlatformMFAType.TOTP]
